import { render, staticRenderFns } from "./ModalPretestInformation.vue?vue&type=template&id=56cf2f09&scoped=true&lang=pug&"
import script from "./ModalPretestInformation.vue?vue&type=script&lang=ts&"
export * from "./ModalPretestInformation.vue?vue&type=script&lang=ts&"
import style0 from "./ModalPretestInformation.vue?vue&type=style&index=0&id=56cf2f09&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56cf2f09",
  null
  
)

export default component.exports